import { useField } from 'formik';
import React, { FC } from 'react';

// Components
import FormikError from '../FormikError';

// Models
import { FormikInputProps } from '../../../models/Formik';

const FormikInput: FC<FormikInputProps & React.InputHTMLAttributes<HTMLInputElement>> = ({
  name,
  label,
  subLabel,
  type,
  placeholder,
  onChange,
  disabled = false,
  ...rest
}) => {
  const [field, meta] = useField(name);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (onChange) {
      onChange(e.target.value);
    }
  }
  return (
    <div className="aea-form-input">
      <label htmlFor={name} className="aea-form-input__label">
        {label}
      </label>
      {subLabel && (
        <label className="aea-form-input__sublabel">{subLabel}</label>
      )}
      <input
        placeholder={placeholder}
        name={name}
        type={type}
        value={field.value}
        disabled={disabled}
        onChange={handleChange}
        onBlur={field.onBlur}
        {...rest}
      />
      {meta.touched && meta.error && <FormikError name={name} />}
    </div>
  );
};

export default FormikInput;
